export const splai = [
   'ANDREI CIPRIAN-DANIEL',
   'MARINCU SORIN ALEXANDRU',
   'FATU MIHAI',
   'OSIAC MIHAIL',
   'PETCU MARIUS',
   'FARCASEL ALBERT-MIRCEA',
   'MARIUS PETCU',
   'COSTEA DANIEL',
];
